import { api } from "@//api";

// The MJPEG stream is an <img src>, which cannot send the bearer header, so
// the stream URL carries a short-lived token (valid for ~60 s to start the
// stream) minted by this authenticated endpoint.
export const getCameraStreamUrl = async (cameraId: string) => {
  const { body } = await api.post<{ token: string }>(
    `/camera/cameras/${cameraId}/stream-token`,
  );
  const query = new URLSearchParams({ t: body.token });
  return `/api/app/v1/camera/cameras/${cameraId}/stream.mjpeg?${query.toString()}`;
};
